import { useFormik } from "formik";
import * as Yup from "yup";

const useRegistrationForm = (handleSubmit) => {
  return useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Էլ․ Հասցեի անվավեր ձևաչափ")
        .required("Պարտադիր դաշտ (Էլ․ Հասցե)"),
      password: Yup.string()
        .min(6, "Ամենաքիչը 6 նիշ")
        .required("Պարտադիր դաշտ (Գաղտնաբառ)"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Գաղտնաբառերը պետք է համընկնեն")
        .required("Պարտադիր դաշտ (Կրկնեք գաղտնաբառը)"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
};

export default useRegistrationForm;
